export default __webpack_public_path__ + "static/media/vmBuilding.f0d4dcfd.gif";